export { default } from './PageDictionary.vue'
